import { Component, OnInit, ElementRef, ViewChild, Injector } from '@angular/core';
import { FormGroup, FormBuilder, ValidationErrors, Validators, FormControl, ValidatorFn, AbstractControl } from "@angular/forms";

import { Subscription } from 'rxjs';
import { Constants } from 'src/app/util/Constants';

import { User } from 'src/app/model/user';
import { UserService } from 'src/app/service/UserService';
import { PasswordValidator } from 'src/app/validator/PasswordValidator';
import { BaseComponent } from '../../common/BaseComponent';
import { ProgressService } from 'src/app/service/ProgressService';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styles: [`
  .toggle-container {
  position: relative;
}

.toggle-container a {
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 10px;
  margin-right: 10px;
}
  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }
`]
})

export class PasswordChangeComponent extends BaseComponent implements OnInit {

  passwordChangeForm: FormGroup;
  restSub: Subscription;
  submitted: boolean;
  showPassword: boolean = false;
  password: string;
  passwordFieldTypeCurrent = 'password';
  passwordFieldTypeNew = 'password';
  passwordFieldTypeConfirm = 'password';
  appErrorPrefix: string = "bss.api.error";
  user: User;
  resendDisabled: boolean = false;
  showPasswordCurrent: boolean = false;
  showPasswordNew: boolean = false;
  showPasswordConfirm: boolean = false;
  pageMsgRendered: boolean;
  
  @ViewChild('pageMsg') pageMsgElement: ElementRef;
  @ViewChild('progressDialog') progressDialogElementRef!: ElementRef<HTMLDialogElement>;

  constructor(
    injector: Injector,
    public rest: UserService,
    public progressService: ProgressService,
    public fb: FormBuilder) {
    super(injector);
    this.submitted = false;
    this.pageMsgRendered = false;
  }

  togglePasswordCurrent() {
    this.showPasswordCurrent = !this.showPasswordCurrent;
  }

  togglePasswordNew() {
    this.showPasswordNew = !this.showPasswordNew;
  }

  togglePasswordConfirm() {
    this.showPasswordConfirm = !this.showPasswordConfirm;
  }

  ngAfterViewInit() {
    this.progressService.setDialog(this.progressDialogElementRef.nativeElement);
  }

  ngAfterViewChecked() {
    if (!this.pageMsgRendered && this.pageMsgElement !== undefined) {
      this.pageMsgElement.nativeElement.focus();
      this.pageMsgElement.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.pageMsgRendered = true;
    }
  }

  ngOnInit(): void {
    this.user = JSON.parse(sessionStorage.getItem("user"));

    if (this.isCertificatelogin) {
      this.router.navigateByUrl('/public/error');
      return;
    }

    this.passwordChangeForm = new FormGroup({
      currentPassword: new FormControl(null,
        Validators.compose([
          Validators.required])),
      oneTimePin: new FormControl(null,
        Validators.compose([
          Validators.required, Validators.pattern(Constants.P_NUMBERS_ONLY), Validators.minLength(8), Validators.maxLength(8)])),
      newPassword: new FormControl(null,
        Validators.compose([
          Validators.required, PasswordValidator.startC, 
          PasswordValidator.strongU, PasswordValidator.strongL, PasswordValidator.strongD, PasswordValidator.strongS, 
          PasswordValidator.strongDS, PasswordValidator.strongR, Validators.maxLength(17), Validators.minLength(12)
        ])),
      confirmPassword: new FormControl(null,
        Validators.compose([
          Validators.required, PasswordValidator.startC, PasswordValidator.strongU, PasswordValidator.strongL,
          PasswordValidator.strongD, PasswordValidator.strongS, PasswordValidator.strongR, Validators.maxLength(17), Validators.minLength(12)]))
    },
      {
        validators: [
          PasswordValidator.matchValidator('newPassword', 'confirmPassword'), 
          PasswordValidator.passwordUserContainsFName(this.user.firstName, 'newPassword'), 
          PasswordValidator.passwordUserContainsLName(this.user.lastName, 'newPassword'), 
          PasswordValidator.mismatchValidator('currentPassword', 'newPassword'),
          PasswordValidator.passwordUserContainsEmail(this.user.email, 'newPassword'),
          
        ]
      });

    this.restSub = this.rest.sendEmailMFA(this.user).subscribe(response => {
      console.log("pass-change-send-email:" + JSON.stringify(response));
      if (response.result == 1) {
        this.appError = true;
        this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;
      } else {
        this.appError = false;
      }
    }, (error) => { this.processError(error) });
  }

  onSubmit(): void {
    this.submitted = true;
    this.pageMsgRendered = true;
    this.appSuccess = false;

    console.log(this.passwordChangeForm.controls['newPassword'].valid);

    if (this.passwordChangeForm.valid) {
      this.isSubmitting = true;
      console.log("submitted");
      const sessionUser = sessionStorage.getItem("user");
      let user = JSON.parse(sessionUser);

      this.progressService.open();

      user.password = this.passwordChangeForm.get("currentPassword").value;
      user.newPassword = this.passwordChangeForm.get("newPassword").value;
      user.confirmNewPassword = this.passwordChangeForm.get("confirmPassword").value;
      user.otp = this.passwordChangeForm.get("oneTimePin").value;
      this.restSub = this.rest.changePassword(user).subscribe(response => {
        console.log("get-data:" + JSON.stringify(response));
        this.isSubmitting = false;
        if (response.result == 1) {
          console.log("password change error: response.error_code=" + response.error_code);

          this.appError = true;
          this.appSuccess = false;
          this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;

          //handle account locked situation
          this.checkIfAccountLocked(response.error_code);
        } else {
          this.appError = false;
          this.router.navigate(['secure/user/password/change/success']);
        }
      }, (error) => {
        this.processError(error);
      },
      () => {
        this.progressService.close();
      });
    }
  }

  onResend(): void {
    this.pageMsgRendered = false;
    this.resendDisabled = true;

    const sessionUser = sessionStorage.getItem("user");
    let user = JSON.parse(sessionUser);
    this.progressService.open();
    this.restSub = this.rest.sendEmailMFA(user).subscribe(response => {
      console.log("pass-change-resend-email:" + JSON.stringify(response));
      if (response.result == 1) {
        this.appSuccess = false;
        this.appError = true;
        this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;
      } else {
        this.appError = false;
        this.appSuccess = true;
        this.appSuccessMessage = this.getMessage("bss.user.email.update.otp.sent.success");
      }
    }, (error) => { 
      this.processError(error);
     },
    () => {
    this.progressService.close();
    }
    );

    setTimeout(() => {
      this.resendDisabled = false;
    }, 60000);

  }

  onCancel(): void {
    this.router.navigate(['secure/profile']);
  }

  ngOnDestroy() {
    if (this.restSub) {
      this.restSub.unsubscribe();
    }
  }

}


